import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch, apiUpload } from './client';
import type { ProjectMedia } from '@spi/shared';

export function useUploadMedia(projectId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (files: File[]) => {
      const formData = new FormData();
      files.forEach((file) => formData.append('files', file));
      return apiUpload<ProjectMedia[]>(`/api/media/projects/${projectId}/media`, formData);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['projects', projectId] }),
  });
}

export function useDeleteMedia() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) =>
      apiFetch(`/api/media/${id}`, { method: 'DELETE' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['projects'] }),
  });
}
